import { Alert } from '@mui/material'
import DashboardLayout from './DashboardLayout'

type Props = {
    loading?: boolean
}

const DashboardLoadingDataView = (props: Props) => {
    return (
        <DashboardLayout loading={props.loading}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 64,
                }}
            >
                <div>
                    <Alert severity="info">Loading data...</Alert>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default DashboardLoadingDataView
